import factory from './icon';
import Svg from './glyphs/mask.svg';

export default factory(Svg);
